import { createContext, useContext } from 'react';

import type { ValidationResult } from '@/components/sg-design-system/components/input/SgDatePicker/Input/useValidationManager.tsx';

import type { Color } from '../../../../types/colors';
import type { DatePickerValidationState } from '../types';

/**
 * Validation context for SgDatePicker
 * Contains validation state and methods
 */
export interface DatePickerValidationContextValue {
  validationState: DatePickerValidationState | null | undefined;
  validationMessage?: string;
  validateDateInput: (dateString: string) => ValidationResult;
  setValidation: (state: DatePickerValidationState | null, message?: string) => void;
  clearValidation: () => void;
  getValidationColor: () => Color;
}

const DatePickerValidationContext = createContext<DatePickerValidationContextValue | undefined>(undefined);

export const DatePickerValidationProvider = DatePickerValidationContext.Provider;

export function useDatePickerValidation(): DatePickerValidationContextValue {
  const context = useContext(DatePickerValidationContext);

  if (!context) {
    throw new Error('useDatePickerValidation must be used within DatePickerValidationProvider');
  }

  return context;
}
